import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  SerializedError,
} from '@reduxjs/toolkit';

import { Category } from '../api/models/Category';
import { GetAllCategories } from '../api/services/categories';

import { SliceCallState } from './sliceCallState';

interface CategoriesAction {
  payload: Category[] & { error?: SerializedError };
  type: string;
}

export interface CategoriesState {
  categories: Category[];
  loading: SliceCallState;
  error?: SerializedError;
}

const initialState: CategoriesState = {
  categories: [],
  loading: SliceCallState.idle,
};

export const getAllCategories = createAsyncThunk<
  Category[],
  undefined,
  { rejectValue: SerializedError }
>('api/categories', async (_, thunkAPI) => {
  try {
    return await GetAllCategories();
  } catch (error) {
    const err = error as SerializedError;
    return thunkAPI.rejectWithValue(err);
  }
});

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (
      state: { categories: Category[] },
      action: CategoriesAction
    ) => {
      state.categories = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<CategoriesState>) => {
    builder.addCase(getAllCategories.pending, (state: CategoriesState) => {
      state.loading = SliceCallState.pending;
    });

    builder.addCase(
      getAllCategories.fulfilled,
      (state: CategoriesState, action: CategoriesAction) => {
        state.categories = action.payload;
        state.loading = SliceCallState.succeeded;
      }
    );

    builder.addCase(getAllCategories.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = SliceCallState.failed;
    });
  },
});

export const { setCategories } = categoriesSlice.actions;
